import React from 'react';
import { X } from 'lucide-react';
import SSODomainManagement from '../admin/SSODomainManagement';

const SSODomainModal = ({ organization, currentUser, onClose }) => {
  if (!organization) return null;

  return (
    <div className="fixed inset-0 bg-ui-overlay bg-opacity-50 flex items-center justify-center z-[70] p-4">
      <div className="bg-ui-surface rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-ui-line">
          <div>
            <h2 className="text-2xl font-bold text-ui-ink">
              Google SSO Domains
            </h2>
            <p className="text-sm text-ui-ink-3 mt-1">
              {organization.name}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-ui-muted hover:text-ui-ink-3 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <SSODomainManagement
            organizationId={organization.id}
            organizationName={organization.name}
            currentUser={currentUser}
          />
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-ui-line bg-ui-sunk">
          <button
            onClick={onClose}
            className="px-4 py-2 text-ui-ink-2 bg-ui-surface border border-ui-control rounded-lg hover:bg-ui-hover transition-colors font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SSODomainModal;
